import { List } from 'immutable';
import React, { PureComponent } from 'react';

import TreeContainer from './TreeContainer';

interface Tree {
	[key: string]: any;
}
interface Props {
	tree: Tree;
	emptyValue: string | null;
}

export default class TreeBrowser extends PureComponent<Props> {
	static defaultProps = {
		emptyValue: null,
	};

	render() {
		const { tree, emptyValue } = this.props;

		return <TreeContainer root emptyValue={emptyValue} path={List()} renderSubTree={this.renderTree} values={tree} />;
	}

	renderTree = (values: Tree, path: List<string>) => (
		<TreeContainer emptyValue={this.props.emptyValue} path={path} renderSubTree={this.renderTree} values={values} />
	);
}
